import { makeStyles } from "@material-ui/core";

export const useCoreInfoRequestStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
  card: {
    marginBottom: theme.spacing(2),
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: 8,
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  cardTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#424242",
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  accordion: {
    marginBottom: theme.spacing(2),
    borderRadius: "8px !important",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    "&:before": {
      display: "none",
    },
  },
  accordionSummary: {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px 8px 0 0",
    "&.Mui-expanded": {
      minHeight: 48,
    },
  },
  historyTable: {
    minWidth: 650,
  },
}));
